import { useMemo } from 'react';
import { useGlobalAlertStore } from 'src/stores/globalAlertStore/globalAlertStore';

/**
 * Hook that provides execution blocking state for components that trigger workflow executions.
 *
 * @returns {object}
 * - `isExecutionBlocked`: true when a global alert is blocking executions
 * - `canUserOverride`: true if the current user belongs to the override bindle
 * - `hasOverridden`: true if the user has clicked the Override button
 * - `isEffectivelyBlocked`: true when execution is blocked AND user hasn't overridden
 * - `blockingMessage`: The blocking alert's header message (for display)
 * - `blockingContent`: The blocking alert's content (for display)
 */
export function useGlobalExecutionGate() {
	const { isExecutionBlocked, blockingAlert, canUserOverride, hasOverridden } = useGlobalAlertStore();

	return useMemo(() => ({
		isExecutionBlocked,
		canUserOverride,
		hasOverridden,
		isEffectivelyBlocked: isExecutionBlocked && !(canUserOverride && hasOverridden),
		blockingMessage: blockingAlert?.header || 'Executions are currently disabled due to a system alert.',
		blockingContent: blockingAlert?.content || '',
	}), [isExecutionBlocked, blockingAlert?.id, blockingAlert?.header, blockingAlert?.content, canUserOverride, hasOverridden]);
}
